var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapStartPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 39C20 38.4477 20.4477 38 21 38H40C40.5523 38 41 38.4477 41 39C41 39.5523 40.5523 40 40 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19 39C19 37.8954 19.8954 37 21 37C22.1046 37 23 37.8954 23 39C23 40.1046 22.1046 41 21 41C19.8954 41 19 40.1046 19 39Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V39C22 39.5523 21.5523 40 21 40V40C20.4477 40 20 39.5523 20 39V14Z",
    fill: "#2D4422"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H40C41.1046 12 42 12.8954 42 14V28C42 29.1046 41.1046 30 40 30H20V12Z",
    fill: "#1D4D08"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H40V28H22V14Z",
    fill: "#7CB342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStartPoint);
export default __webpack_public_path__ + "static/media/map_start_point.b20c2d42eeb9ea90e3e013eb4e369397.svg";
export { ForwardRef as ReactComponent };